import { ModalType } from 'common/common-models';
import React from 'react';
import { Button } from 'react-bootstrap';
import { Partner, PartnerFilters } from './models';

interface PartnersSearchBarProps {
    filters: PartnerFilters;
    onFilter: (filter: PartnerFilters) => void;
    openPartnerModal: (modalType: ModalType, partner?: Partner) => void;
}

export const PartnersSearchBar = (props: PartnersSearchBarProps) => {

    const onInputChange = (inputEvent: any) => {
        props.onFilter({
            search: inputEvent.target.value
        });
    };

    return (
        <div className="electricity-invoices__search-bar bar-position">
            <h2 className="text-light">
                Partnerid
            </h2>
            <div className="card mb-5 shadow">
                <div className="card-body">
                    <div className="d-flex flex-wrap flex-sm-nowrap">
                        <input
                            placeholder="Nimi"
                            className='search-bar__input p-2'
                            onChange={onInputChange}
                            value={props.filters.search || ''}
                        />
                        <div className="d-flex flex-nowrap ml-auto">
                            <Button className="ml-auto d-flex align-items-center"
                                    onClick={() => props.openPartnerModal(ModalType.CREATE)}
                                    variant={"primary"}>
                                <i className="icon--16 icon__add d-flex mr-1"/>
                                <span>Uus partner</span>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
